import React, { useEffect } from 'react';
import { BrowserRouter, Switch, Route, useHistory } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { Middleware } from './lib/Router'
import Layout from './layouts/layout/index';
import './index.css';
import { CookiesProvider } from 'react-cookie';
import theme from './theme';
import { AppProvider } from './context/AppContext';

import Login from './layouts/login/index';
import RecoveryPassword from './layouts/login/recoverPassword';
import ClaimCodePage from './insfrastructure/pages/claim';
import NavigationService from './utils/history';
import { ApplicationsConnector } from './application/Applications';

require('./utils/prototypes');

function App() {
	// Manejo seguro de errores globales
	window.onerror = function (message, source, lineno, colno, error) {
		// Solo loggear en desarrollo
		if (process.env.NODE_ENV === 'development') {
			console.error(`Error global: ${message} en ${source}:${lineno}:${colno}`, error);
		}
		
		// En producción, enviar a servicio de logging (si está disponible)
		// logger.error('Global error', { message, source, lineno, colno, error });
		
		// No exponer información sensible
		return true; // Previene el log por defecto del navegador
	};

	window.addEventListener('unhandledrejection', function (event) {
		// Solo loggear en desarrollo
		if (process.env.NODE_ENV === 'development') {
			console.error('Unhandled rejection:', event.reason);
		}
		
		// En producción, enviar a servicio de logging
		// logger.error('Unhandled promise rejection', { reason: event.reason });
		
		// Prevenir el log por defecto
		event.preventDefault();
	});

	return (
		<ThemeProvider theme={theme}>
			<AppProvider>
				<ApplicationsConnector />
				<CookiesProvider>
					<BrowserRouter>
						<NavigationHandler />
						<Switch>
							<Route exact path="/login" component={Login}></Route>
							<Route exact path="/recovery" component={RecoveryPassword}></Route>
							<Route exact path="/claim/:code" component={ClaimCodePage}></Route>
							<Route path="/" component={() => Middleware(Layout)} />
							{/* <Route path="/" component={PublicPageBranch} /> */}
						</Switch>
					</BrowserRouter>
				</CookiesProvider>
			</AppProvider>
		</ThemeProvider>
	);
}

const NavigationHandler = () => {
	const history = useHistory(); // useHistory debe estar dentro de un Router

	React.useEffect(() => {
		NavigationService.setHistory(history);
	}, [history]);

	return null;
};



export default App;
